import React from 'react';
import {connect} from "react-redux";

import {setShowJobEditPopup} from "../../actions/A_Popups";


const JobBoardJobInvoiceButton = (props) => {

  const {job, setShowJobEditPopup} = props;

  const jobPaymentClick = () => {
    console.log("job", job);
    setShowJobEditPopup(true, job);
    // setShowJobPaymentPopup(true, job);
  }

  return (
    <button className={"ui-button5 ui-button5--green mt-15 ml-175"}
            onClick={jobPaymentClick}
            disabled={false}>
      Configure Invoice
    </button>
  )
};

const mapStateToProps = () => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
  };
};

const mapDispatchToProps = {
  setShowJobEditPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardJobInvoiceButton)
